module.exports = __webpack_public_path__ + "asset/img/guid-beil.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/images/guid-beil.svg
// module id = 873
// module chunks = 2 3